import React, { useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import './RewardsModal.module.css'
import Accordion from 'react-bootstrap/Accordion';
import { dataContext } from '../../../App';
import activityLogSubmission from '../../../helper/activitylog';
import analyticEvent from '../../../helper/gaEvent';
import { pushCleverTapEvent } from '../../../helper/clevertapFunction';
import styles from './RewardsModal.module.css'
import './RewardsModal.css'

const RewardsModal = ({ showRewardsModal, setShowRewardsModal }) => {
  const { playerData } = useContext(dataContext);

  function hideModalOperation() {
    setShowRewardsModal(false)
  }

  useEffect(() => {
    let msisdn = null;
    if (playerData?.id) {
      msisdn = playerData?.msisdn;
    }
    activityLogSubmission("rewards", msisdn);
    analyticEvent('rewards', 'rewards-view')
    // pushCleverTapEvent('CheckIn-Prize');
  }, [])

  return (
    <>
      <div className={styles.rewardsModal}>
        <div className={styles.rewardsModalHeader}>
          <img src={require('./rewards.png')} className={styles.rewardsModalIcon} alt="medal" />
          <span className={styles.rewardsModalTitle}>প্রাইজের তালিকা</span>
        </div>
        <div className={styles.specialNote} style={{marginTop: '10px' }}>
          <p>
          QUIZARD কর্তৃপক্ষ বিজয়ীদের দৈনিক, টুর্নামেন্ট ভিত্তিক পুরস্কার প্রদান করে থাকে ।
          </p>
        </div>
        <Accordion className={styles.accordion}>
          <Accordion.Item eventKey="4" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>টুর্নামেন্ট এর সময়সীমা</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>১লা জুলাই ২০২৬ থেকে ৩১শে ডিসেম্বর ২০২৬</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>সাপ্তাহিক ক্যাম্পেইন এর সময়সীমা</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>প্রতি সোমবার থেকে রবিবার পর্যন্ত।</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
          <Accordion.Item eventKey="0" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>কুইজ প্রতিদিন পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>Sports Quiz পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>BCS প্রস্তুতি পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3" className={styles.accordionItem}>
            <Accordion.Header className={styles.accordionButton}>টুর্নামেন্ট কুইজ পুরস্কার</Accordion.Header>
            <Accordion.Body className={styles.accordionBody}>
              <ul>
                <li>মেগা পুরস্কার: Samsung Galaxy A07</li>
                <li>প্রতিদিন: শীর্ষ ২০ জন ১০ টাকা মোবাইল রিচার্জ</li>
              </ul>
              ***এক সপ্তাহের ডেইলি প্রাইজ একসাথে সপ্তাহের সোমবার দেয়া হয়ে থাকে।
              <br />
              বিঃ দ্রঃ টুর্নামেন্টের মেগা উইনার হতে হলে ব্যবহারকারীকে সাবস্ক্রাইব করার দিন থেকে নিয়মিত সাপ্তাহিক রিনিউ রাখতে হবে, সার্ভিসে সক্রিয়ভাবে খেলতে হবে এবং টপ স্কোরার হতে হবে।
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  )
}

export default RewardsModal